import React from 'react';
import { Box, Paper, Typography, useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useMatrixData } from '../usePlotData';

export const TableChart = ({ klausimas, atsakymai }) => {
    const { data, legend } = useMatrixData(klausimas, atsakymai);
    const theme = useTheme();

    if (!data || !legend) return null;

    const chartTitle = klausimas?.title?.[klausimas?.defaultLocale || 'lt'] || '';

    return (
        <Box sx={{ width: '100%', p: 2 }}>
            <Typography
                variant="h6"
                sx={{
                    color: theme.palette.text.primary,
                    fontWeight: 500,
                    mb: 3
                }}
            >
                {chartTitle}
            </Typography>
            <Paper
                elevation={2}
                sx={{
                    p: 3,
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    transition: 'box-shadow 0.3s ease',
                    '&:hover': {
                        boxShadow: theme.shadows[4],
                    }
                }}
            >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell 
                                    sx={{ 
                                        fontWeight: 'bold',
                                        backgroundColor: theme.palette.grey[100]
                                    }}
                                >
                                    Klausimas
                                </TableCell>
                                {legend.map((item) => (
                                    <TableCell 
                                        key={item.name}
                                        align="center"
                                        sx={{ 
                                            fontWeight: 'bold',
                                            backgroundColor: theme.palette.grey[100]
                                        }}
                                    >
                                        {item.name}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row, index) => (
                                <TableRow 
                                    key={index}
                                    sx={{
                                        '&:nth-of-type(odd)': {
                                            backgroundColor: theme.palette.grey[50],
                                        }
                                    }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.text}
                                    </TableCell>
                                    {row.ats.map((answer, i) => (
                                        <TableCell 
                                            key={i} 
                                            align="center"
                                            sx={{
                                                color: theme.palette.text.secondary,
                                                fontWeight: answer.val > 50 ? 'bold' : 'normal'
                                            }}
                                        >
                                            {answer.val.toFixed(1)}%
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};
